/**
 * Application entry point.
 *
 * Mounts the root React component into the DOM using React 18's
 * createRoot API, wrapped in StrictMode for development warnings.
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
